import React from "react";
import PropTypes from "prop-types";
import {Button, Upload, message} from "antd";
import {BaseComponent} from '@cm-sites-webber/components';
import {PIC_TYPE_PDF} from '@cm-sites-webber/components/es/constants';
import ImageView from "../components/imgView";
import { getInfoFromLocalStorage } from "../../../../../../actions";
import './style.css';

const InputProps = {...Upload.defaultProps, ...Upload.propTypes}

/**
 * uploadRecord组件
 */
export default class UploadRecord extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            loading: false,
            value: {},
            customInfo: {},
        };

        this.imageRef = React.createRef();
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
        this.getSystemInfo();
    }

    getSystemInfo = () => {
        const url = '/cm-sites-media-consumer/system/getCustomInfo';
        new Promise((resolve,reject) => {
            this.request({
                url,
                method: 'get',
                callBack: (res) => {
                    resolve(res)
                },
                errorCallBack:(err)=> {
                    reject(err)
                }
            })
        }).then((res) => {
            let customInfo = {};
            if(res) {
                customInfo = res;
            }
            this.setState({
                customInfo
            })
        }).catch((err) => {
            message.destroy();
            message.error(err);
        })
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(UploadRecord.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }
    downloadTemplate = () => {
        let res = this.state.customInfo;
        let url = `${res.positionRecord.recordedInfo.path}?download=1`;
        let aObj = document.createElement('a');
        aObj.setAttribute('download','');
        aObj.setAttribute('href',url);
        aObj.target='_blank';
        aObj.click();
    }

    viewPic = (file) => {
        let suffix = file.name.split(".").at(-1);
        if(suffix === "pdf") {
            window.open(file.path);
        }else {
            this.imageRef.current.show();
        }
    }

    render() {
        const {prefixLayout, suffixLayout, style = {}, suffixButton, disabled} = this.props.fieldProps;
        const {fieldProps, suffixWidth, value} = this.state;
        let Token = getInfoFromLocalStorage('Token');

        const recordListProps = {
            name: 'file',
            accept: "." + [...PIC_TYPE_PDF].join(",."),
            showUploadList: false,
            beforeUpload: file => {
                this.setState({
                    loading: true
                })
                let fileName = file.name.split('.');
                let upload = fileName.at(-1).toUpperCase();
                upload = PIC_TYPE_PDF.includes(upload);
                if(!upload){
                    message.error('暂不支持该文件类型！');
                }
                return new Promise((resolve, reject) => {
                    if (!upload) {
                        this.setState({
                            loading: false
                        })
                        reject(file);
                    } else {
                        resolve(file);
                    }
                });
            },
            action: "/dynamic/storage/uploadFile",
            headers: {Authorization: 'Bearer ' + Token},
            onSuccess: (response, file) => {
                let data = response?.data ? response?.data : null;
                if (response && response.status === 200) {
                    if (typeof this.props.fieldProps.onChange === "function") {
                        this.props.fieldProps.onChange(data);
                    }
                    message.success("上传备案表成功");
                } else {
                    message.error("上传备案表失败！");
                }
                this.setState({
                    loading: false,
                    value: data,
                })
            },
            onError: () => {
                message.error("上传备案表失败！");
                this.setState({
                    loading: false,
                })
            }
            // customRequest: ({file}) => {
            //     let url = "/storage/uploadFile";
            //     let fd = new FormData();
            //     fd.append("file", file);
            //     this.request({
            //         url, body: fd, method: "post", contentType: "upload", callBack: (fileInfo) => {
            //             let that = this;
            //             if (fileInfo) {
            //                 that.state.recordTable = fileInfo ? fileInfo : null;
            //                 message.success("上传备案表成功");
            //                 that.setState({
            //                     loading: false,
            //                 })
            //             } else {
            //                 message.error("上传备案表失败！");
            //             }
            //         }, errorCallBack: () => {

            //         }, serverVerify: {
            //             serverErrorCallBack: () => {

            //             }
            //         }
            //     });
            // }
        };
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout && <div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={{...style, flexGrow: 0}}>
                        {
                            value && value.path ?
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                }}>
                                    <a title={value.name} style={{
                                        overflow: "hidden",
                                        display: "block",
                                        width: "158px",
                                        textOverflow: "ellipsis",
                                        lineClamp: 1,
                                        whiteSpace: "nowrap",
                                        maxLength: 17,
                                        fontSize: 14
                                    }} onClick={() => {
                                        this.viewPic(value);
                                    }}>{value.name}</a>
                                    <ImageView ref={this.imageRef} path={value.path}/>
                                    <Button style={{
                                        marginRight: "16px",
                                        marginLeft: 5,
                                        background: "#fff",
                                        border: "1px solid rgba(0, 0, 0, 0.15)"
                                    }}
                                            disabled={disabled}
                                            onClick={() => {
                                                value.path = ""
                                                this.setState({})
                                                if (typeof this.props.fieldProps.onChange === "function") {
                                                    this.props.fieldProps.onChange(null);
                                                }
                                            }}>删除</Button>
                                    <Upload {...recordListProps}>
                                        <Button style={{
                                            background: "#fff",
                                            border: "1px solid rgba(0, 0, 0, 0.15)"
                                        }}
                                                icon="upload" loading={this.state.loading}
                                                disabled={disabled}>重新上传</Button>
                                    </Upload>
                                </div>
                                :
                                (<div>
                                    <Upload {...recordListProps}>
                                        <Button style={{ background: "#F6F8FD" }} icon="upload" loading={this.state.loading}
                                            disabled={disabled}>上传备案表</Button>
                                    </Upload>
                                    <div className="rmt-input-suffix-layout" style={{ marginLeft: 10 }}>
                                        {this.state.customInfo?.positionRecord?.recordedInfo?.path && <div><a onClick={this.downloadTemplate}>点击下载模板</a></div>}
                                    </div>
                                </div>
                                
                                )

                        }
                    </div>
                </div>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

UploadRecord.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

UploadRecord.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}